
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/configurator",
      function () {
        return require("private-next-pages/configurator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/configurator"])
      });
    }
  